/**
 * Chat list row helpers (UI only).
 * Event wiring resta in chatRow.ts / homeScreen.ts.
 */
import { createChatRow, type ChatRowOptions } from '../chatRow.ts'
import { el, escapeHtml } from '../dom.ts'

export type GlassChatCardOptions = ChatRowOptions & {
  timeLabel?: string
}

/** Riga chat stile Android: stessa logica di createChatRow + meta timestamp. */
export function createGlassChatCard(opts: GlassChatCardOptions): HTMLElement {
  const row = createChatRow(opts)
  row.classList.add('az-chat-row')
  row.classList.remove('zg-card')
  if (opts.hasUnread) row.classList.add('has-unread')

  const meta = row.querySelector('.chat-row-meta')
  if (meta && opts.timeLabel) {
    const time = el(`<span class="az-time">${escapeHtml(opts.timeLabel)}</span>`)
    meta.prepend(time)
  }

  // Badge non letti a destra: dopo orario, prima dei bottoni nascosti
  const badge = row.querySelector('.unread-badge')
  const timeEl = row.querySelector('.az-time')
  if (meta && badge && timeEl) {
    meta.insertBefore(timeEl, meta.firstChild)
    meta.appendChild(badge)
  }

  const openBtn = row.querySelector('.chat-row-open')
  openBtn?.addEventListener(
    'pointerdown',
    () => {
      row.parentElement?.querySelectorAll('.chat-row.is-focused, .list-item.is-focused').forEach((n) => {
        n.classList.remove('is-focused')
      })
      row.classList.add('is-focused')
    },
    { passive: true },
  )

  return row
}

export { createChatRow }
